export interface LinhaObservacaoRelatorio {
  observacao?: string | null;
  substituidoNaData?: boolean;
  placaAtual?: string | null;
}

export function montarObservacaoRelatorio(d: LinhaObservacaoRelatorio): string {
  const observacao = (d.observacao ?? '').trim();

  const notaSubstituicao = d.substituidoNaData
    ? `Placa vigente na data consultada (veículo substituído).${d.placaAtual ? ` Placa atual: ${d.placaAtual}.` : ''}`
    : '';

  return [observacao, notaSubstituicao].filter(Boolean).join(' — ');
}
